<template>
  <div>
    <div class="specification-wrapper">
      <div class="d-flex" style="gap: 20px">
        <div class="w-100">
          <input-radio
            label="Screen Panel"
            name="screen-panel"
            :value="forms.productDetail.displayType"
            @change="
              (val) =>
                $emit('handleChangeInput', 'productDetail.displayType', val)
            "
            type="horizontal"
            :options="displayTypeOptions"
            styleType="button"
            :disabled="!!catalogId"
            :error="
              (errors &&
                errors.productDetail &&
                errors.productDetail.displayType) ||
              null
            "
          />
        </div>
        <div class="w-100">
          <input-radio
            label="HDMI Port"
            name="hdmi-port"
            :value="forms.productDetail.portHdmi"
            @change="
              (val) => $emit('handleChangeInput', 'productDetail.portHdmi', val)
            "
            type="horizontal"
            :options="portOptions"
            styleType="button"
            :disabled="!!catalogId"
            :error="
              (errors &&
                errors.productDetail &&
                errors.productDetail.portHdmi) ||
              null
            "
          />
        </div>
      </div>
      <div class="d-flex mt-4" style="gap: 20px">
        <div class="w-100">
          <input-radio
            label="VGA Port"
            name="vga-port"
            :value="forms.productDetail.portVga"
            @change="
              (val) => $emit('handleChangeInput', 'productDetail.portVga', val)
            "
            type="horizontal"
            :options="portOptions"
            styleType="button"
            :disabled="!!catalogId"
            :error="
              (errors &&
                errors.productDetail &&
                errors.productDetail.portVga) ||
              null
            "
          />
        </div>
        <div class="w-100">
          <input-radio
            label="Port DVI-D"
            name="dvi-port"
            :value="forms.productDetail.portDvid"
            @change="
              (val) => $emit('handleChangeInput', 'productDetail.portDvid', val)
            "
            type="horizontal"
            :options="portOptions"
            styleType="button"
            :disabled="!!catalogId"
            :error="
              (errors &&
                errors.productDetail &&
                errors.productDetail.portDvid) ||
              null
            "
          />
        </div>
      </div>
    </div>
    <br />
    <div class="specification-wrapper">
      <div class="d-flex align-items-center mb-3" style="gap: 0.5rem">
        <div>
          <img
            src="~@/assets/icon/desktop-purple.svg"
            alt="verified"
            width="24"
          />
        </div>
        <h5 class="section-title mb-0">Display</h5>
      </div>
      <div class="d-flex" style="gap: 1rem">
        <div class="w-50">
          <input-text
            id="screen"
            label="Screen"
            :value="forms.productDetail.displaySize"
            placeholder="e.g. 15.6"
            showSuffixLabel
            @change="
              (val) => $emit('handleChangeInput', 'productDetail.displaySize', val)
            "
            :error="
              (errors && errors.productDetail && errors.productDetail.displaySize) ||
              null
            "
            :disabled="!!catalogId"
          >
            <template #suffix-label>inch</template>
          </input-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { error } from "shelljs";
import { InputText, InputRadio } from "../../../Input";

export default {
  name: "Monitor",
  components: {
    InputText,
    InputRadio,
  },
  props: {
    errors: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    forms: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      portOptions: [
        { label: "Support", value: "Tersedia" },
        { label: "No", value: "Tidak Ada" },
      ],
      displayTypeOptions: [
        { label: "LCD", value: "lcd" },
        { label: "LED", value: "led" },
      ],
    };
  },
  computed: {
    catalogId() {
      const id = Number(this.$route.params.id);
      return isNaN(id) ? 0 : id;
    },
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 700;
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
}

.section-description {
  font-weight: 400;
  font-size: 0.875rem;
}

.specification-wrapper {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 0.5rem;
}

.bg-white {
  background: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/Catalog/Components/TechSpec/Monitor.vue